import React, { useEffect, useRef, useCallback } from "react";
import Select from "react-select";
import validator from "validator";
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useParams, useHistory } from "react-router-dom";
import { userAdded, userGetById, verifEmail, verification, fetchUsers, fetchUsersGrossiste, fetchSite, userGetByIdSite } from "../../../Redux/usersReduce";
import { fetchGrossiste } from "../../../Redux/grossisteReduce";
import { fetchRole } from "../../../Redux/roleReduce";
import { getActiveLigne } from "../../../Redux/ligneImsReduce";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from 'react-multi-lang'

function AjouterUser({ client }) {
  const t = useTranslation();
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }
  const customStyles = {
    control: (provided) => ({
      ...provided,
      maxHeight: '300px', // Set the maximum height
      overflowY: 'auto',   // Enable vertical scrolling
      border: '1px solid #283c5a', // Re-add your border
      // You may need to set 'height: 100%' or simply omit it for max-height to work
    }),
    // You might also need to style the value container if the control style doesn't fully contain it
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '298px', // Slightly less than control height
      overflowY: 'auto',
      flexWrap: 'wrap', // Ensure tags wrap correctly
    }),
  };

  const dispatch = useDispatch();
  const navigate = useHistory();
  var token = localStorage.getItem("x-access-token");
  const location = useParams();
  //input
  const [nom, setNom] = React.useState("");
  const [tel, setTel] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [email2, setEmail2] = React.useState(null);
  const [email3, setEmail3] = React.useState(null);
  const [login, setLogin] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [code, setCode] = React.useState("");
  const [role, setRole] = React.useState(0);
  const [grossiste, setGrossiste] = React.useState(null);
  const [id, setId] = React.useState(0);
  const [idLine, setIdLine] = React.useState(null);
  const [idLineSelect, setIdLineSelect] = React.useState(null);
  const [idManager, setIdManager] = React.useState(null);
  const [remise, setRemise] = React.useState(0);
  const [grosArraySelect, setGrosArraySelect] = React.useState([]);
  //required
  const [nomRequired] = React.useState(true);
  const [emailRequired] = React.useState(true);
  const [loginRequired] = React.useState(true);
  const [passwordRequired] = React.useState(true);
  const [roleRequired] = React.useState(true);
  const saveCalled = useRef(false);

  const etat = 1;

  const [options, setOptions] = React.useState([
    {
      value: "",
      label: "Role",
      isDisabled: true,
    },
  ]);

  const [optionsSite, setOptionsSite] = React.useState([]);

  const [optionsManager, setOptionsManager] = React.useState([
    {
      value: "",
      label: "manager",
      isDisabled: true,
    },
  ]);

  const [roleSelect, setRoleSelect] = React.useState({
    value: 0,
    label: "Role",
  });

  const [siteSelect, setSiteSelect] = React.useState(null);
  const [optionsLigne, setOptionsLigne] = React.useState([]);

  const [optionsGros, setOptionsGros] = React.useState([
    {
      value: "",
      label: "Grossiste",
      isDisabled: true,
    },
  ]);


  const [grosSelect, setGrosSelect] = React.useState({
    value: null,
    label: "Grossiste",
  });

  const getGrossisteUser = useCallback(async (id) => {
    var response = await dispatch(fetchUsers());
    var responseUser = await dispatch(fetchUsersGrossiste({ id: location.id }));
    var data = response.payload;
    var existeGros = responseUser.payload;
    var arrayOption = [];
    data.forEach((e) => {
      if (e.id_role == 6 && e.etat == 1 && (!existeGros[e.id])) {
        arrayOption.push({ value: e.id, label: e.nom_prenom });
      }
    });
    setOptionsGros(arrayOption);
  }, [dispatch]);

  const getSite = useCallback(async (id) => {
    var response = await dispatch(fetchSite());
    var data = response.payload;
    var arrayOption = [];
    data.forEach((e) => {
      if (e.id != 1) {
        arrayOption.push({ value: e.id, label: e.nom });
      }
    });
    setOptionsSite(arrayOption);
  }, [dispatch]);

  const getLigne = useCallback(
    async (p) => {
      var ligne = await dispatch(getActiveLigne());
      var entities = ligne.payload;
      var arrayOption = [];
      entities.forEach((e) => {
        arrayOption.push({ value: e.id, label: e.nom });
        if (e.id === p) {
          console.log(e.id, p)
          setIdLineSelect({ value: e.id, label: e.nom });
        }
      });
      setOptionsLigne(arrayOption);
    },
    [dispatch]
  );

  const getManager = useCallback(async (p) => {
    var response = await dispatch(fetchUsers());
    var data = response.payload;
    var arrayOption = [];
    data.forEach((e) => {
      if (e.id_role == 4 && e.etat == 1) {
        arrayOption.push({ value: e.id, label: e.nom_prenom });
        if (e.id === p) {
          console.log(e.id, p)
          setIdManager({ value: e.id, label: e.nom_prenom });
        }
      }
    });
    setOptionsManager(arrayOption);
  }, [dispatch]);

  const getGrossiste = useCallback(async (p) => {
    var type = await dispatch(fetchGrossiste());
    var data = type.payload;
    var arrayOption = [];
    data.forEach((e) => {
      arrayOption.push({ value: e.id, label: e.Raison_sociale });
      if (e.id === p) {
        setGrosSelect({ value: e.id, label: e.Raison_sociale });
      }
    });
    setOptionsGros(arrayOption);
  }, [dispatch]);


  async function submitForm(event) {
    var required = document.getElementsByClassName("required");
    var testPassword = true;
    saveCalled.current = false;
    for (var i = 0; i < required.length + 1; i++) {
      if (required[i] !== undefined) {
        document.getElementsByClassName("error")[i].innerHTML = "";
        required[i].style.borderColor = "#ccc";
        //condition required      
        if (validator.isEmpty(required[i].value) && required[i].name !== "Password") {
          required[i].style.borderColor = "red";
          document.getElementsByClassName("error")[i].innerHTML = required[i].name + " est obligatoire";
          notify(2, required[i].name + " doit etre non vide");
        }
        //condition email
        else if (required[i].name === "Email" && !validator.isEmail(required[i].value)) {
          notify(2, "E-mail invalide");
          document.getElementsByClassName("error")[i].innerHTML = "E-mail invalide";
        }
        //condition password
        else if ((required[i].name === "Password" && isNaN(location.id) === true) ||
          (required[i].name === "Password" && !validator.isEmpty(required[i].value) && isNaN(location.id) === false)) {
          if (!validator.isLength(required[i].value, { min: 11, max: 40 })) {
            testPassword = false;
            notify(2, t("User.password_minimum"));
            document.getElementsByClassName("error")[i].innerHTML = t("User.password_minimum");
          }
        }
      }
    }



    if (email !== "" && !validateMail()) {
      notify(2, t("User.email_invalid"));
      return;
    }

    if (email2 !== null && validator.isEmail(email2)) {
      notify(2, t("User.email_invalid"));
      return;
    }

    if (email3 !== null && validator.isEmail(email3)) {
      notify(2, t("User.email_invalid"));
      return;
    }

    const emailCheckResult = await checkEmail();
    if (emailCheckResult) {
      return;
    }

    var roleClass = document.querySelector("#roleClass .react-select__control");
    roleClass.style.borderColor = "#ccc";
    if (role === 0) {
      roleClass.style.borderColor = "red";
      notify(2, "Choisire un role");
    }


    if (!validator.isEmpty(nom) && siteSelect.length > 0 && validator.isEmail(email) && !validator.isEmpty(login) && testPassword === true &&
      (role > 0) && ((role == 6 && grossiste > 0) || (role > 0 && (grossiste == 0 || grossiste == null))) && ((role == 3 && idManager && grosArraySelect.length > 0) || (role > 0 && (idManager == null)))) {
      if (saveCalled.current) return;
      saveCalled.current = true;
      dispatch(userAdded({ site: siteSelect, remise, email2, email3, nom, crm: code, email, tel, id_line: idLine, login, password, id, etat, role, grossiste, idManager, grosArraySelect })).then(data => {
        if (data.payload === true) {
          if (isNaN(location.id) === true) {
            notify(1, t("add_txt"))
            setTimeout(async () => {
              listeUser();
            }, 800);
          } else {
            notify(1, t("update_txt"));
            setTimeout(async () => {
              listeUser();
            }, 800);
          }
        } else {
          saveCalled.current = false;
          notify(2, t("problem"));
        }
      });
    } else {
      saveCalled.current = false;
      notify(2, t("erreur"));
    }
  }



  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
    async function getRole(p) {
      var role = await dispatch(fetchRole());
      var entities = role.payload;
      var arrayOption = [];
      arrayOption.push({ value: 0, label: "Role" });
      entities.forEach((e) => {
        arrayOption.push({ value: e.id, label: e.nom });
        if (e.id === p) {
          setRoleSelect({ value: e.id, label: e.nom });
        }
      });
      setOptions(arrayOption);
    }

    const promise = new Promise((resolve, reject) => {
      setTimeout(async () => {
        if (isNaN(location.id) === false) {
          var user = await dispatch(userGetById(location.id));
          var userSite = await dispatch(userGetByIdSite(location.id));
          var entities = user.payload;
          setNom(entities.nom_prenom);
          setEmail(entities.email);
          setEmail2(entities.email2);
          setEmail3(entities.email3);
          setLogin(entities.login);
          setSiteSelect(userSite.payload);
          setTel(entities.tel);
          setRole(entities.id_role);
          setIdLine(entities.id_line);
          setRemise(entities.remise);
          setGrossiste(entities.id_grossiste);
          setCode(entities.crm);
          setId(location.id);
          resolve(entities);
        } else {
          resolve(0);
        }
      }, 0);
    });


    promise.then((value) => {
      var roles = 0;
      var line = 0;
      var grossistes = 0;
      var manager = 0;

      if (value !== 0) {
        if (value.id_role == 3) {
          var arrayOpGro = []
          value.listeGrossiste.forEach((e) => {
            arrayOpGro.push({ value: e.id, label: e.nom_prenom });
          });
          setGrosArraySelect(arrayOpGro)
        }
        roles = value.id_role;
        line = value.id_line;
        grossistes = value.id_grossiste;
        manager = value.id_manager;

      }
      getRole(roles);
      getLigne(line)
      getSite()
      if (roles == 6 || role == 6) {
        getGrossiste(grossistes);
      } else { getGrossisteUser(location.id); }
      getManager(manager);
    });

  }, [location.id, dispatch,role]);



  function listeUser() {
    navigate.push(client + '/utilisateurListe');
  }


  const validateMail = () => {
    const mailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return mailRegex.test(email);
  };


  const validateTel = () => {
    const telRegex = /^[0-9]{8}$/;
    return telRegex.test(tel);
  };


  const checkEmail = async () => {
    try {
      var response = await dispatch(verifEmail({ id: id, email: email }));
      if (response.payload === true) {
        notify(2, "Adresse email existe déja");
        return true;
      }
      return false;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };


  return (
    <>
      <Container fluid>
        <ToastContainer />
        <div className="section-image">
          <Row>
            <Col md="12">
              <Button
                id="saveBL"
                className="btn-wd btn-outline mr-1 float-left"
                type="button"
                variant="info"
                onClick={listeUser}
              >
                <span className="btn-label">
                  <i className="fas fa-list"></i>
                </span>
                {t("list")}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Title as="h4">
                      {typeof location.id == "undefined"
                        ? t("User.add")
                        : t("User.update")}
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>{t("User.name")} & {t("User.last_name")}* </label>
                          <Form.Control
                            defaultValue={nom}
                            placeholder={t("User.name") + " & " + t("User.last_name")}
                            name="Nom"
                            className="required"
                            type="text"
                            onChange={(value) => {
                              setNom(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                        <div className="error"></div>
                        {nomRequired ? null : (
                          <label className="error">
                            {t("User.nom_obligatoire")}
                          </label>
                        )}
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label>  {t("User.password")} * </label>
                          <Form.Control
                            defaultValue={password}
                            placeholder={t("User.password")}
                            className="required"
                            name="Password"
                            type="password"
                            onChange={(value) => {
                              setPassword(value.target.value);
                            }}
                          ></Form.Control>
                          <div className="error"></div>
                          {passwordRequired ? null : (
                            <label className="error">
                              {t("User.password_obligatoire")}
                            </label>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>  {t("User.login")} * </label>
                          <Form.Control
                            defaultValue={login}
                            placeholder={t("User.login")}
                            className="required"
                            name="Login"
                            type="text"
                            onChange={(value) => {
                              setLogin(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                        <div className="error"></div>
                        {loginRequired ? null : (
                          <label className="error">
                            {t("User.login_obligatoire")}
                          </label>
                        )}
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label>{t("User.tel")}({t("huitcaractere")}) </label>
                          <Form.Control
                            defaultValue={tel}
                            placeholder={t("User.tel")}
                            type="number"
                            onChange={(value) => {
                              setTel(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>{t("User.email")}* </label>
                          <Form.Control
                            defaultValue={email}
                            placeholder={t("User.email")}
                            name="Email"
                            className="required"
                            type="text"
                            onChange={(value) => {
                              setEmail(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                        <div className="error"></div>
                        {emailRequired ? null : (
                          <label className="error">
                            {t("User.email_obligatoire")}
                          </label>
                        )}
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group id="roleClass">
                          <label>{t("User.role")}* </label>
                          <Select
                            placeholder="Role"
                            className="react-select primary"
                            classNamePrefix="react-select"
                            value={roleSelect}
                            onChange={(value) => {
                              setRoleSelect(value);
                              setRole(value.value);
                            }}
                            options={options}
                          />
                        </Form.Group>
                        {roleRequired ? null : (
                          <div className="error">
                            {t("User.role_obligatoire")}
                          </div>
                        )}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label>Code CRM  </label>
                          <Form.Control
                            defaultValue={code}
                            placeholder="Code CRM "
                            name="Code"
                            type="text"
                            onChange={(value) => {
                              setCode(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group>
                          <label>Ligne </label>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            value={idLineSelect}
                            placeholder="Ligne"
                            onChange={(value) => {
                              setIdLineSelect(value);
                              setIdLine(value.value);
                            }}
                            options={optionsLigne}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>{t("User.email")}2  </label>
                          <Form.Control
                            defaultValue={email2}
                            placeholder={t("User.email")}
                            name="Email2"
                            type="text"
                            onChange={(value) => {
                              setEmail2(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col className="pl-1" md="6">
                        <Form.Group id="roleClass">
                          <label>Industrie * </label>
                          <Select
                            placeholder="Industrie"
                            className="react-select primary"
                            classNamePrefix="react-select"
                            value={siteSelect}
                            isMulti
                            onChange={(value) => {
                              setSiteSelect(value);
                            }}
                            options={optionsSite}
                          />
                        </Form.Group>

                      </Col>
                      <Row>
                        <Col className="pr-1" md="6">
                          <Form.Group>
                            <label>{t("User.email")}3  </label>
                            <Form.Control
                              defaultValue={email3}
                              placeholder={t("User.email")}
                              name="Email3"
                              type="text"
                              onChange={(value) => {
                                setEmail3(value.target.value);
                              }}
                            ></Form.Control>
                          </Form.Group>
                          <div className="error"></div>

                        </Col>
                      </Row>
                    </Row>
                    {role == 6 ?
                      <Row>
                        <Col className="pr-1" md="6">
                          <Form.Group id="roleClass">
                            <label>Grossiste* </label>
                            <Select
                              placeholder="Grossiste"
                              className="react-select primary"
                              classNamePrefix="react-select"
                              value={grosSelect}
                              onChange={(value) => {
                                setGrosSelect(value);
                                setGrossiste(value.value);
                              }}
                              options={optionsGros}
                            />
                          </Form.Group>
                        </Col>
                        {/* <Col className="pr-1" md="6">
                        <Form.Group>
                          <label>Remise  </label>
                          <Form.Control
                            defaultValue={remise}
                            placeholder={"Remise"}
                            name="remise"
                            type="number"
                            onChange={(value) => {
                              setRemise(value.target.value);
                            }}
                          ></Form.Control>
                        </Form.Group>                 
                      </Col> */}
                      </Row> : null}

                    {role == 3 ?
                      <Row>
                        <Col className="pr-1" md="6">
                          <Form.Group id="roleClass">
                            <label>Manager* </label>
                            <Select
                              placeholder="Manager"
                              className="react-select primary"
                              classNamePrefix="react-select"
                              value={idManager}
                              onChange={(value) => {
                                setIdManager(value);
                              }}
                              options={optionsManager}
                            />
                          </Form.Group>
                        </Col>
                        <Col className="pr-1" md="6">
                          <Form.Group id="roleClass">
                            <label>Grossiste* </label>
                            <Select
                              isMulti
                              placeholder="Grossiste"
                              className="react-select primary"
                              classNamePrefix="react-select"
                              value={grosArraySelect}
                              onChange={(value) => {
                                setGrosArraySelect(value);
                              }}
                              options={optionsGros}
                              // --- Apply the custom styles here ---
                              styles={customStyles}
                            />
                          </Form.Group>
                        </Col>
                      </Row> : null}
                    <br>
                    </br>

                    <br></br>
                    <Button
                      className="btn-fill pull-right"
                      type="button"
                      variant="info"
                      onClick={submitForm}
                    >
                      {t("save")}
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

export default AjouterUser;
